<form [formGroup]='formGroup' class='widget'>
  <pt-input-label
    *ngIf='label'
    [inputId]='inputId'
    [isRequired]='isRequired'
    [label]='label'
    style='display: contents'
  ></pt-input-label>

  <div [ngStyle]='{"padding-left": label ? "20px": ""}'>
    <div *ngFor='let option of options; let i = index'
         class="form-check">

      <input [id]="inputId + '_' + i"
             [ngClass]="{'form-check--disabled': option.disabled, 'text-muted': option.disabled,'p-0': !!label}"
             [value]=option.value
             class="form-check-input"
             formControlName='value'
             type="radio">
      <label [for]="inputId + '_' + i" class="form-check-label ms-2">
        {{ option.label | async }}
      </label>
    </div>
    <ng-content select='[inputInfo]'></ng-content>
  </div>


  <!--  <div class='form-group' [ngStyle]='{"padding-left": label ? "20px": ""}'>-->
  <!--    <div class='form-check'-->
  <!--         [ngClass]="{'form-check&#45;&#45;disabled': option.disabled, 'text-muted': option.disabled,'p-0': !!label}"-->
  <!--         *ngFor='let option of options; let i = index'>-->
  <!--      <input-->
  <!--        [ngClass]="{'form-check-input&#45;&#45;disabled': option.disabled}"-->
  <!--        class='form-check-input'-->
  <!--        formControlName='value'-->
  <!--        type='radio'-->
  <!--        [value]=option.value-->
  <!--        [id]="inputId + '_' + i"-->
  <!--      >-->
  <!--      <label class='form-check-label' [for]="inputId + '_' + i">-->
  <!--        {{option.label | async}}-->
  <!--      </label>-->
  <!--    </div>-->
  <!--    <ng-content select='[inputInfo]'></ng-content>-->
  <!--  </div>-->
</form>
